import copy from "@/services/copy";
export default function makeValueData(mapTo, doCopy = true) {

    function safeCopy(val) {
        if(doCopy) {
            return copy(val);
        }
        return val;
    }

    return {
        props: {
            value: {
                type: Object,
                required: true,
            },
        },
        data() {
            const copyed = safeCopy(this.value);
            const data = {};
            mapTo(copyed, data, this, true);
            return data;
        },
        watch: {
            value: {
                handler(val) {
                    const copyed = safeCopy(val);
                    mapTo(copyed, this, this, true);
                },
                deep: true,
            },
        },
        methods: {
            computeOutput() {
                const out = {};
                mapTo(this, out, this, false);
                return out;
            },
            changed() {
                const out = this.computeOutput();
                this.$emit("input", out);
            },
        },
    };
}
